import { BaseItemStore } from "../core/BaseStore";
import type SectionModel from "./SectionModel";

export default class SectionsStore extends BaseItemStore<SectionModel> {}
